// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"qaa-z","narrowOptionButtons":"raa-z","noOptions":"saa-z"};